module.exports = __webpack_public_path__ + "assets/img/b4-7.4a055636.png";